import React, { Component, useState } from 'react';
import { Button, Row, Col, Pagination } from 'react-bootstrap'
import "react-datepicker/dist/react-datepicker.css";
import $, { data } from 'jquery'
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import PocketbookStudentSumary from "../../components/PocketbookStudentSumary";
import { withRouter } from 'react-router-dom';
import {Helmet} from "react-helmet";

class PocketbookStudentList extends Component {
    constructor(props) {
        super(props);         
        console.log(this.props.match.params.roomId)
        this.state = {
            message: [], 
            filter: [],          
            data: null,
            roomId: this.props.match.params.roomId,
            pagination: [],
            user: AuthService.getCurrentUser(),
            role: AuthService.getUserRole(),         
            tabKey: 'student',          
            dataMode: 'student',         
            classMainBg: 'bg-white',      
            classFillter: 'bg-white',
            classShadow: '',
            report1: 'btn-mm-blue',
            report2: 'btn-mm-outline-blue',
            teacherId: '',
            menuText: 'ประเมินตัวเอง'
        };
    }

    componentDidMount() {
        this.setState({ dataMode: 'student' });
        this.studentList();
        this.getFilter('student');
    }

    studentList() {     
        
        this.setState({ message: <PocketbookStudentSumary roomId={this.state.roomId} /> });
    }

    getFilter(tabKey, inputs = null) {
        this.setState({ tabKey: tabKey });
        this.setState({
            classFillter:'bg-white'
        });
        if(tabKey === 'student') {        
            this.setState({
                filter: ''                   
            });
        } 
    }

    updateContent(menu, inputs = []) {
        var data = '';     
        if(menu === 'student'){
           this.studentList();     
           this.getFilter(menu);      
    
        }         
    }

    render() {
        return ( 
            <div className={`evaluate-report`}>
                <Helmet>
                    <title>การประเมินอุปนิสัยเชิงบวกของนักเรียน และตัวครู - Mindsetmaker.co</title>
                    <meta property="og:title"       content={`การประเมินอุปนิสัยเชิงบวกของนักเรียน และตัวครู - Mindsetmaker.co`} />
                    <meta property="og:description" content={`กิจกรรมประเมินด้วยการค้นหาสิ่งดีๆ ในช่วงเวลาที่ผ่านมา เพื่อค้นพบอุปนิสัยเชิงบวกในตัวเรา เพื่อนๆและคุณครู`} />
                </Helmet>                     
                <Row>
                    <div className={`py-0 px-0 w-100 pt-3 ${this.state.classMainBg} `}>                  
                        <div className={`px-4 pt-3 ${this.state.classFillter} ${this.state.classShadow}`} >
                            <div className="main-detail">
                                {this.state.filter}
                            </div>
                        </div>
                        <div className="text-center data-div px-3 font-sarabun">
                            {this.state.message}
                        </div>
                    </div>
                </Row>
            </div>
            
        );
    }

}

export default withRouter(PocketbookStudentList);